<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/user">{{ $t('user_list') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{$t('user_create')}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="clickSaveHandler"><i class="fa fa-floppy-o"></i> {{$t('save')}}</button>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-header">
                    <div class="card-item upper">{{ $t('user_create') }}</div>
                </div>
                <div class="card-body">
                    <div v-if="$v.$error" class="alert alert-danger x-error">
                        <div class="error" v-if="!$v.model.UserName.required">- សូមធ្វើកាបញ្ចូលឈ្មោះ</div>
                        <div class="error" v-if="!$v.model.PhoneNumber.required">- សូមធ្វើកាបញ្ចូលលេខទូរស័ព្ទ</div>
                        <div class="error" v-if="!$v.model.Verify.sameAsPassword">- សូមធ្វើការពិនិត្យលេខសំងាត់ម្តងទៀត</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group" :class="{ 'form-group-error': $v.model.UserName.$error }">
                                <label class="label-control blue">{{$t('user_name')}}</label>
                                <input type="text" class="form-control" v-model="$v.model.UserName.$model" />
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group" :class="{ 'form-group-error': $v.model.PasswordHash.$error }">
                                        <label class="label-control blue">{{$t('user_password')}}</label>
                                        <input type="password" class="form-control" v-model="$v.model.PasswordHash.$model" />
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group" :class="{ 'form-group-error': $v.model.Verify.$error }">
                                        <label class="label-control blue">{{$t('user_confirm_password')}}</label>
                                        <input type="password" class="form-control" v-model="$v.model.Verify.$model" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group" :class="{ 'form-group-error': $v.model.DisplayName.$error }">
                                        <label class="label-control blue">{{$t('display_name')}}</label>
                                        <input type="text" class="form-control" v-model="$v.model.DisplayName.$model" />
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group" :class="{ 'form-group-error': $v.model.Email.$error }">
                                        <label class="label-control blue">{{$t('user_email')}}</label>
                                        <input type="email" class="form-control" v-model="$v.model.Email.$model" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group" :class="{ 'form-group-error': $v.model.PhoneNumber.$error }">
                                        <label class="label-control blue">{{$t('phone')}}</label>
                                        <input type="text" class="form-control" v-model="$v.model.PhoneNumber.$model" />
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group" :class="{ 'form-group-error': $v.model.GroupId.$error }">
                                        <label class="label-control blue">{{$t('user_group')}}</label>
                                        <select class="form-control" v-model="$v.model.GroupId.$model" @change="groupChange">
                                            <option v-for="ret in groups" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <template v-for="(ret,index) in modules">
                                        <template v-if="ret.Children.length>0">
                                            <div :key="index" style="padding: 10px 0;border-bottom: 1px solid #ddd;font-weight: 700;color: #0856ab;">{{ret.Name}}</div>
                                            <div v-for="item in ret.Children" :key="item.Id" style="padding: 5px;border-bottom: 1px solid #f2f2f2;">
                                                <input type="checkbox" v-model="item.Checked"/> {{item.Name}}
                                            </div>
                                        </template>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="row">
                                <div class="col-sm-12">
                                    <input type="file" ref="file" @change="fileChangeHandler" style="display:none;"/>
                                    <img :src="img" alt="" class="img-thumbnail" style="width: 150px; height:135px;" @click="$refs.file.click()">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>          
        </div>
    </div>
</template>
<script>
import { required, sameAs, minLength } from 'vuelidate/lib/validators';
export default {
    data: function(){
        return {
            model: {
                UserName: '',
                Email: '',
                PasswordHash: '',
                Verify: '',
                PhoneNumber: '',
                DisplayName: '',
                GroupId: ''
            },
            img: '/img/no-image.svg',
            file: '',
            formHead: { headers: { 'Content-Type': 'multipart/form-data' }},
            groups: [],
            modules: []
        }
    },
    validations:{
        model: {
            UserName: { 
                required,
                minLength: minLength(6)
            },
            PasswordHash: {
                required,
                minLength: minLength(6)
            },
            Verify: { 
                sameAsPassword: sameAs('PasswordHash')
            },
            Email: { required },
            PhoneNumber: { required },
            DisplayName: { required },
            GroupId: { required }
        }
    },
    created(){
        this.listGroup();
    },
    methods: {
        clickSaveHandler: function(){
            this.$v.$touch();
            if(!this.$v.$invalid) {
                let loading = this.$loading.show();
                var formData = new FormData();
                formData.append('File', this.$refs.file.files[0]);
                formData.append('UserName', this.model.UserName);
                formData.append('Email', this.model.Email);
                formData.append('PasswordHash', this.model.PasswordHash);
                formData.append('PhoneNumber', this.model.PhoneNumber);
                formData.append('GroupId', this.model.GroupId);
                formData.append('DisplayName', this.model.DisplayName);
                let jsonMenus = [];
                this.modules.forEach(el => {
                    for(var i = 0; i < el.Children.length; i++){
                        let item = el.Children[i];
                        if(item.Checked){
                            jsonMenus.push({
                                MenuId: item.Id
                            });
                        }
                    }
                });
                formData.append("JsonMenu", JSON.stringify(jsonMenus));
                this.$api().post('account/register', formData, this.formHead).then(res => {
                    if(this.$isValid(res)){
                        this.$router.push('/user');
                    }
                }).finally(function(){ loading.hide(); });
            }
        },
        fileChangeHandler: function(){
            this.img = URL.createObjectURL(this.$refs.file.files[0]);
        },
        listGroup(){
            this.$api().post('user/groups', {}).then(res => {
                if(this.$isValid(res)){
                    this.groups = res.data.Json.Groups;
                }
            });
        },
        groupChange(){
            let loading = this.$loading.show();
            this.$api().post('user/module-group', { GroupId: this.model.GroupId}).then(res => {
                if(this.$isValid(res)){
                    this.modules = res.data.Json.Modules;
                }
            }).finally(() => loading.hide());
        }
    }
}
</script>

